export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyBDeDutwrJxG8iB8Xpjne1WpRh5D4FyCsA",
        authDomain: "medpal-dev-cfc0a.firebaseapp.com",
        databaseURL: "https://medpal-dev-cfc0a-default-rtdb.firebaseio.com",
        projectId: "medpal-dev-cfc0a",
        storageBucket: "medpal-dev-cfc0a.appspot.com",
        messagingSenderId: "438779153925",
        appId: "1:438779153925:web:036f654646c4a7df85966c",
        measurementId: "438779153925"
    },
    baseURL: "https://app-hkiydwmleq-uc.a.run.app",
    recaptchaSiteKey: "6LfyuUIrAAAAAEHlK1vEly9i7ybGr_hj2U2wtm1y"
};